import { DateTime } from 'luxon';

import {
  isToday,
  isTomorrow,
} from '@/helpers/dateUtils';
import { i18n } from '@/i18n';

export default function useTimeslotHelpers() {
  const buttonDate = (timeslot, timezone, full = false) => {
    const today = DateTime.local().startOf('day');
    const formatedDay = DateTime.fromISO(timeslot, {
      zone: timezone,
    });

    if (isToday(formatedDay)) {
      return i18n.t('search.today');
    }

    if (isTomorrow(formatedDay)) {
      return i18n.t('search.tomorrow');
    }

    if (formatedDay.diff(today, ['days']).days > 6) {
      return `${formatedDay.toFormat('LLLL')} ${formatedDay.toFormat('d')}`;
    }

    if (full) {
      return formatedDay.toFormat('cccc');
    }

    return formatedDay.toFormat('ccc');
  };

  return { buttonDate };
}
